export default "__VITE_ASSET__idVzhyC2__"